module.exports = __webpack_public_path__ + "static/media/schoolpic02@3x.faa921c1.png";